// extracted by mini-css-extract-plugin
export var container = "PagePrivateTours-module--container--1JChw";
export var background = "PagePrivateTours-module--background--1tbrO";
export var backgroundColor = "PagePrivateTours-module--backgroundColor--37jSr";
export var content = "PagePrivateTours-module--content--3m7xd";
export var main = "PagePrivateTours-module--main--1r8Zs";
export var imageContainer = "PagePrivateTours-module--imageContainer--1uVCy";
export var image = "PagePrivateTours-module--image--1Mtq_";